<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">超时时间设置(分钟)</span>
    </div>
    <el-form ref="dialogForm" :model="dialogForm" label-width="260px">
      <el-row :gutter="20" v-for="(item, index) in dialogForm.b2cSystemTaskTimeLimits" :key="index">
        <el-col :span="12">
          <el-form-item :label="item.b2cTaskType+'-操作超时'" >
            <el-input v-model="item.operationTimeLimit" placeholder="操作时间"></el-input>
          </el-form-item>
          <el-form-item :label="item.b2cTaskType+'-下单超时'" >
            <el-input v-model="item.orderTimeLimit" placeholder="下单时间"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-form>
      <el-row :gutter="30" style="text-align: center">
        <el-col span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">返回</el-button>
        </el-col>
        <el-col span="10" style="text-align: left">
          <el-button type="primary" icon="el-icon-folder" @click="update">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import MixinCUD from "@/components/MixinCUD";
import {querySystemTaskTimeLimit, updateSystemTaskTimeLimit} from "../../api/b2cbusiness/b2c_admin";
export default {
  name: "TaskTimeConfig",
  mixins:[MixinCUD],
  data(){
    return {
      dialogRefName: "dialogForm",
      dialogForm:{
        b2cSystemTaskTimeLimits:[],
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      querySystemTaskTimeLimit().then(res=>{
        if (res.success){
          this.dialogForm.b2cSystemTaskTimeLimits = res.data;
        }
      });
    },
    update(){
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                updateSystemTaskTimeLimit(this.dialogForm.b2cSystemTaskTimeLimits).then(res=>{
                  if (res.success){
                    this.$message.success("更新数据成功！");
                    this.getData();
                  }
                });
                //取消新增或修改也要重置表单
              });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
